import moment from 'moment';

import { TipoBuscaEnum, TipoPesquisaEnum } from '@interfaces';

import * as Estilos from './styles';

interface PropriedadesValores {
  numeroDiario?: string;
  texto?: string;
  dataInicial?: string;
  dataFinal?: string;
  tipoBuscaTexto?: string;
}

interface PropriedadesAviso {
  valores: PropriedadesValores;
  tipoPesquisa?: TipoPesquisaEnum;
}

export const CardDeResultado: React.FC<PropriedadesAviso> = ({
  valores,
  tipoPesquisa,
}: PropriedadesAviso) => {
  const descricaoTipoDeBusca = () => {
    switch (valores.tipoBuscaTexto) {
      case TipoBuscaEnum['Busca Exata' as keyof object]:
        return 'Exata';
      case TipoBuscaEnum['Ao menos uma palavra' as keyof object]:
        return 'Ao menos uma palavra';
      default:
        return '';
    }
  };

  const mensagem = () => {
    switch (tipoPesquisa) {
      case TipoPesquisaEnum.numerica:
        return `Você está vendo: Diário Oficial número <strong>${valores.numeroDiario}</strong>`;

      case TipoPesquisaEnum.textual:
        return `
        Você está vendo: Tipo de busca <strong>${descricaoTipoDeBusca()}</strong>${
          valores.texto && `, que contém o texto <strong>${valores.texto}</strong>`
        }${
          valores.dataInicial &&
          `, a partir de <strong>${moment(valores.dataInicial).format('DD/MM/YYYY')} </strong>`
        }${valores.dataFinal && ` até <strong>${moment(valores.dataFinal).format('DD/MM/YYYY')}`}${
          valores.numeroDiario && `, no diário de número <strong>${valores.numeroDiario} </strong>`
        }
      `;

      case TipoPesquisaEnum.periodo:
        return `Você está vendo: Diários${
          valores.dataInicial &&
          ` a partir de <strong>${moment(valores.dataInicial).format('DD/MM/YYYY')}</strong>`
        }${
          valores.dataFinal &&
          ` até <strong>${moment(valores.dataFinal).format('DD/MM/YYYY')}</strong>`
        }`;

      default:
        return '';
    }
  };

  return (
    <Estilos.Conteiner>
      <h3>Resultado de sua busca</h3>

      <Estilos.MensagemGeral>
        <p dangerouslySetInnerHTML={{ __html: mensagem() }} suppressHydrationWarning={true}></p>
      </Estilos.MensagemGeral>
    </Estilos.Conteiner>
  );
};
